import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import "../style.css";

const NavigationBar = observer(({ model }) => {
  return (
    <nav className="navigation-bar">
      <Link to="/" className="nav-logo-link">ArtXplorer</Link>
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/browse">Browse</Link>
        <Link to="/quiz">Quiz</Link>
        <Link to="/favorites">Favorites</Link>
      </div>
      <div className="nav-login">
        <Link to="/login">{model.isLoggedIn ? "Profile" : "Log in"}</Link>
      </div>
    </nav>
  );
});

export default NavigationBar;
